<!-- Footer -->
<footer class="app-footer" style="clear: both">
  <div class="flexible scrollToTop-wrapper width-100">
    <a href="javascript:void(0);" title="Scroll to top" class="inline-block" id="scrollToTop"><img src="assets/imgs/scrolltop.png" alt="Scroll to top"></a>
  </div>
  <div class="container">
    <div class="row">
      <ul class="main flexible flexible-row compact-children-padding">
        <li class="col-xs-12 col-lg-3 footer-col">
          <header class="text-uppercase">akces</header>
          <ul>
            <li><a href="//pro.akces.fr" title="Découvrez AKCES"><i class="fa fa-angle-right"></i> {{'footer.discover'| translate}} AKCES</a></li>
            <li><a [routerLink]="['/faq']" title="Questions / Réponses"><i class="fa fa-angle-right"></i> {{'footer.question'| translate}} / {{'footer.answer'| translate}}</a></li>
            <li><a [routerLink]="['/cg']" title="Conditions générales de vente"><i class="fa fa-angle-right"></i> {{'footer.general_sales_conditions'| translate}}</a></li>
          </ul>
        </li>
        <li class="col-xs-12 col-lg-3 footer-col">
          <header class="text-uppercase">{{'footer.contact'| translate}}</header>
          <ul>
            <li><a [routerLink]="['/contact']" title="Contact"><i class="fa fa-angle-right"></i> {{'footer.contact'| translate}}</a></li>
            <li><a [routerLink]="['/join-us']" title="Nous rejoindre"><i class="fa fa-angle-right"></i> {{'footer.join_us'| translate}}</a></li>
          </ul>
        </li>
        <li class="col-xs-12 col-lg-3 footer-col text-center" id="solution-pro1" *ngIf="url.indexOf('landing') < 0">
          <span>pro</span>
          <p style="color: white">
            {{'footer.Access_control'| translate}}
            <br>{{'footer.Professional_Solutions'| translate}}
          </p>
          <a class="btn" href="//pro.akces.fr" taret="_blank">{{'footer.discover1'| translate}}</a>
        </li>
        <li class="col-xs-12 col-lg-3 footer-col text-center" id="solution-pro" *ngIf="url.indexOf('landing') >= 0">
          <span>{{'footer.agenda'| translate}}</span>
          <p>
            {{'footer.Events_from_here_and_elsewhere'| translate}}
          </p>
          <a class="btn" href="http://akces.fr"> {{'footer.Consult'| translate}}</a>
        </li>
        <li class="col-xs-12 col-lg-3 footer-col text-center" id="akces-rest">
          <a href="//pro.akces.fr/landing/pro"><img src="assets/imgs/{{logoName}}" alt="Logo AKCES" class="inline-block"></a>
          <p class="text-italic">
            {{'footer.Agenda_ticketing_and_more'| translate}}
          </p>
          <a href="//app.akces.fr/landing/pro"  title="Créer un évènement" class="btn inline-block"> {{'footer.Create_an_event'| translate}}</a>
          <ul id="social-nets">
            <li><a href="https://www.facebook.com/akces.fr" title="Facebook"><i class="fa fa-facebook"></i></a></li>
            <li><a href="/" title="Twitter"><i class="fa fa-twitter"></i></a></li>
            <li><a href="https://www.instagram.com/akces.fr/" title="Instagram"><i class="fa fa-instagram"></i></a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="sub-footer">
    <div class="container">
      <div class="row">
        <ul class="compact-children-margin">
          <li><a [routerLink]="['/mentions-legales']" title="Mentions légales">{{'footer.Legal_Notice'| translate}}</a></li>
          <li>Copyright &copy; Akces 2018</li>
        </ul>
      </div>
    </div>
  </div>
</footer>
